import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NbLayoutModule } from '@nebular/theme';
import { BannerRendererComponent, BlogListRendererComponent, CategoryRendererComponent, DynamicRendererComponent, GridCell, GridRendererComponent, ProductRendererComponent, RendererDataInterFace, RowCell, RowRendererComponent, StorethemesModule, TestimonialRendererComponent } from '@urbannex/storethemes';
import { PreviewModule } from '../../../preview/preview.module';
import { IframeCommunicationService } from '../../../services/iframe-communication.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Section } from '../../../editor-container/editor-model';
import { RenderCellDirective } from '../render-cell.directive';
import { SectionAttributesDirective } from '../../../preview/render-preview-sections/preview-section/section-attributes.directive';

@Component({
  standalone: true,
  selector: 'kve-responsive-preview',
  imports:[
    CommonModule,
    NbLayoutModule,
    StorethemesModule,
    PreviewModule
  ],
  template:`
  <nb-layout>
    <nb-layout-column>
        <ng-container *ngIf="isLoaded">
            <!-- <p>Fokof POlisie kar</p> -->
            <kw-preview-section kwSectionAttributes [attr.section-id]="section.sectionId" [section]="section" [attr.renderer-type]="section.rendererType"></kw-preview-section>
            <!-- <ng-template #previewHost kveRenderCell [section]="section" [activeSelector]="activeSelector" [rendererComponent]="rendererComponent" [selectedCell]="selectedCell"  [selectedTabTitle]="selectedTabTitle" [posChange]="posChange"></ng-template> -->
        </ng-container>
  </nb-layout-column>
</nb-layout>
  `,
  // templateUrl: './responsive-preview.component.html',
  styleUrls: ['./responsive-preview.component.scss']
})
export class ResponsivePreviewComponent implements OnInit,OnDestroy,AfterViewInit {
  //section
  //rendererComponent
  //selectedCell
  //selectedTabTitle
  responsiveConf$:Subscription;
  section:Section;
  rendererType:string;
  selectedCell:GridCell | RowCell;

  rendererComponent:DynamicRendererComponent;

  isLoaded:boolean = false;

  
  destroy$:Subject<void> = new Subject<void>()
  
  
  constructor(private communicator: IframeCommunicationService,
    private cdref: ChangeDetectorRef) { }
  

  ngOnInit(): void {
    
  }

  ngAfterViewInit(): void {
    this.responsiveConf$ = this.communicator.receiveFromParent("responsiveConf").pipe(takeUntil(this.destroy$))
    .subscribe(info => {
      console.log(info);
      this.section = info.data.section;
      this.rendererType = info.data.rendererType;
      this.selectedCell = info.data.selectedCell;
      setTimeout(() => {
        //this.loadComponent(this.rendererComponent.component);
        this.isLoaded = true;
        this.cdref.detectChanges();
      },1000)
      console.log(this.section);
      //this.cdref.detectChanges();
      /* this.resolveRenderer(this.rendererType);
      if(this.rendererComponent != undefined){
        setTimeout(() => {
          this.loadComponent(this.rendererComponent.component);
          this.cdref.detectChanges();
        },2000)
      } */
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
